export type PhotoReportStatus = "pending" | "restored" | "deleted";
export type PhotoReportReason = "inappropriate" | "fake" | "other";

export interface PhotoReportUserSummary {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface PhotoReportUserImage {
  userId: number;
  photoUrl: string;
  photoUrlHd: string;
  status: string;
  deletionCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface PhotoReportListItem {
  id: number;
  reportedUserId: number;
  reporterUserId: number;
  reason: PhotoReportReason;
  comment: string | null;
  status: PhotoReportStatus;
  resolvedBy: number | null;
  createdAt: string;
  resolvedAt: string | null;
  reportedUser: PhotoReportUserSummary | null;
  reporterUser: PhotoReportUserSummary | null;
  userImage: PhotoReportUserImage | null;
}

export interface PhotoReportListResponse {
  items: PhotoReportListItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface PhotoReportListParams {
  status?: PhotoReportStatus;
  reason?: PhotoReportReason;
  page?: number;
  pageSize?: number;
}

export interface PhotoReportDetail {
  report: {
    id: number;
    reportedUserId: number;
    reporterUserId: number;
    reason: PhotoReportReason;
    comment: string | null;
    status: PhotoReportStatus;
    resolvedBy: number | null;
    createdAt: string;
    resolvedAt: string | null;
  };
  userImage: PhotoReportUserImage | null;
  reportedUser: PhotoReportUserSummary | null;
  reporterUser: PhotoReportUserSummary | null;
}

export const photoReportReasonLabels: Record<PhotoReportReason, string> = {
  inappropriate: "Inapropiado",
  fake: "Falso/Suplantación",
  other: "Otro",
};

export const photoReportStatusLabels: Record<PhotoReportStatus, string> = {
  pending: "Pendiente",
  restored: "Restaurada",
  deleted: "Eliminada",
};
